import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from '../Views/SiteHeader';
import ContactFooter from '../Components/ContactFooter';
import { projectsAlphabetical } from '../data/projects';
import './Index.css';

// Small "hover intent" delay: the preview only changes once the cursor has
// rested on an item this long. Boundary micro-jitter between two adjacent rows
// fires far faster than this, so it can no longer flip the image back and forth.
const HOVER_SETTLE_MS = 60;

const Index = () => {
  const [preview, setPreview] = useState(null);
  // Remember the last previewed project so it can fade out gracefully.
  const lastProjectRef = useRef(null);
  const timerRef = useRef(null);

  // Preload preview images so switching is instant (no blank frame).
  useEffect(() => {
    projectsAlphabetical.forEach((project) => {
      const img = new Image();
      img.src = project.img;
    });
    return () => clearTimeout(timerRef.current);
  }, []);

  const schedulePreview = (value) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setPreview(value), HOVER_SETTLE_MS);
  };

  if (preview) lastProjectRef.current = preview;
  const previewProject = lastProjectRef.current;

  return (
    <div className="index-page">
      <SiteHeader />

      <main className="index-main">
        {/* Clear only when leaving the whole list, so moving between items
            never resets the preview to null (no unmount/remount flicker). */}
        <ul className="index-list" onMouseLeave={() => schedulePreview(null)}>
          {projectsAlphabetical.map((project) => (
            <li key={project.to}>
              <Link
                to={project.to}
                className="index-item"
                onMouseEnter={() => schedulePreview(project)}
              >
                {project.title}
              </Link>
            </li>
          ))}
        </ul>

        <div
          className={`index-preview${preview ? ' is-visible' : ''}`}
          aria-hidden="true"
        >
          {previewProject?.video ? (
            <video
              key={previewProject.to}
              className="index-preview__media"
              src={previewProject.video}
              poster={previewProject.img}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            />
          ) : (
            previewProject?.img && (
              <img
                className="index-preview__media"
                src={previewProject.img}
                alt=""
              />
            )
          )}
        </div>
      </main>

      <ContactFooter />
    </div>
  );
};

export default Index;
